import React from 'react';
import { motion } from 'framer-motion';
import './Blogs.css';

const Blogs = () => {


/*  const blogs = [
    {
      title: "10 Effective Study Techniques for College Students",
      author: "Dr. Sarah Johnson",
      date: "December 10, 2024",
      category: "Study Tips",
      excerpt: "Discover proven study methods that can help you excel in your academic journey and improve your learning efficiency.",
      readTime: "5 min read"
    },
    {
      title: "How to Write a Winning College Application Essay",
      author: "Michael Chen",
      date: "December 8, 2024",
      category: "College Applications",
      excerpt: "Learn the essential elements of a compelling college essay that will make your application stand out from the crowd.",
      readTime: "7 min read"
    },
    {
      title: "The Importance of Time Management in Academic Success",
      author: "Emily Rodriguez",
      date: "December 5, 2024",
      category: "Academic Success",
      excerpt: "Explore how proper time management can significantly impact your academic performance and reduce stress levels.",
      readTime: "4 min read"
    },
    {
      title: "Preparing for Standardized Tests: A Comprehensive Guide",
      author: "Dr. Sarah Johnson",
      date: "December 3, 2024",
      category: "Test Preparation",
      excerpt: "Get expert tips and strategies for preparing for SAT, ACT, and other standardized tests effectively.",
      readTime: "8 min read"
    },
    {
      title: "Building Confidence in Public Speaking",
      author: "Michael Chen",
      date: "November 30, 2024",
      category: "Communication Skills",
      excerpt: "Develop essential public speaking skills that will benefit you throughout your academic and professional life.",
      readTime: "6 min read"
    },
    {
      title: "The Role of Parents in Student Success",
      author: "Emily Rodriguez",
      date: "November 28, 2024",
      category: "Parenting",
      excerpt: "Understanding how parents can support their children's educational journey without being overbearing.",
      readTime: "5 min read"
    }
  ]; */

  return (
    <div className="blogs-page">
      <section className="blogs-hero section">
        <div className="container">
          <motion.div 
            className="blogs-hero-content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h1 className="section-title">Stay Updated!</h1>
            <p className="section-subtitle">
            This page is currently being updated. Please check back soon for the latest content.
            </p>
          </motion.div>
        </div>
      </section>
      </div>);
};

export default Blogs;
